import { useEffect, useState } from "react";

// Captures the browser's "install this app" prompt (Chrome / Edge / Android)
// so we can offer our own Install button. `canInstall` is false once the app
// is installed, when already running as the installed app, or on browsers
// that don't support the prompt (iOS Safari: Share → Add to Home Screen).
export default function useInstallPrompt() {
  const [deferred, setDeferred] = useState(null);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    const onInstalled = () => setDeferred(null);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice.catch(() => null);
    setDeferred(null);
  };

  return { canInstall: !!deferred, install };
}
